/** Defaults match DB `markets` columns when unset (legacy rows). */
const DEFAULT_PERFORMANCE_FEE_ON_PROFIT = 0.15;

export type SharePricedFeeSource = {
  fee_percentage?: number | null;
};

/** Fraction of *realised profit* taken as the performance fee bucket (before creator/affiliate splits). */
export function performanceFeeRateOnProfit(market: SharePricedFeeSource): number {
  const v = market.fee_percentage;
  if (v == null || Number.isNaN(Number(v))) return DEFAULT_PERFORMANCE_FEE_ON_PROFIT;
  const n = Number(v);
  return n >= 0 && n <= 1 ? n : DEFAULT_PERFORMANCE_FEE_ON_PROFIT;
}

export function formatRateAsPercent(rate: number, fractionDigits = 1): string {
  return `${(rate * 100).toFixed(fractionDigits)}%`;
}
